import { render, staticRenderFns } from "./Cashback.vue?vue&type=template&id=cdb66ac6&scoped=true"
import script from "./Cashback.vue?vue&type=script&lang=ts"
export * from "./Cashback.vue?vue&type=script&lang=ts"
import style0 from "./Cashback.vue?vue&type=style&index=0&id=cdb66ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb66ac6",
  null
  
)

export default component.exports